import { atom } from 'jotai';
import { $PageLevelTraffic } from 'shared/atoms';
import { EPageType, IArticlePageTraffic, IVideoPageTraffic } from 'shared/models';
import { pendingQueue } from '~/utils/pending-queue';

export const $CurrentArticleId = atom((get) => {
  const traffic = get($PageLevelTraffic);
  const { pageType } = traffic;

  if (![EPageType.article, EPageType.video].includes(pageType)) {
    console.log('>>>>>>>', 'get current article', 'return promise');
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw new Promise((resolve) => pendingQueue.push(resolve));
  }

  const articleTraffic = traffic as IArticlePageTraffic | IVideoPageTraffic;

  return articleTraffic.groupId;
});
